<div class="dropdown-container">
  <button class="btn-icon trigger-btn" (click)="toggle()" [class.active]="isOpen" type="button">
    <hugeicons-icon [icon]="triggerIcon" [size]="20" color="currentColor"></hugeicons-icon>
  </button>

  @if (isOpen) {
    <div class="dropdown-menu">
      @for (item of actions; track item) {
        <button class="menu-item" [class.danger]="item.variant === 'danger'"
          (click)="handleAction(item.action)">
          @if (item.icon) {
            <hugeicons-icon [icon]="item.icon" [size]="18" color="currentColor"></hugeicons-icon>
          }
          <span class="label">{{ item.label }}</span>
        </button>
      }
    </div>
  }
</div>